<template>
  <v-card id="SeloEcotraceCard" class="Ecotrace-card">
    <v-btn
      absolute
      right
      fab
      small
      depressed
      color="white"
      class="close-btn secondary--text"
      @click="close"
    >
      <v-icon>fas fa-times</v-icon>
    </v-btn>
    <v-card-text class="px-8">
      <v-row class="mt-8">
        <v-col class="d-flex justify-center align-center">
          <v-img
            src="@/assets/icons/selo.png"
            max-width="254"
            max-height="224"
          ></v-img>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="text-center">
          <p
            class="secondary--text text-uppercase font-weight-medium subtitle-1 mb-0 mt-2"
          >
            {{ texts.seloecotrace_title }}
          </p>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="text-center">
          <p class="px-3">
            {{ texts.seloecotrace_text }}
          </p>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: ["texts"],
  methods: {
    close() {
      this.$store.state.seloEcotrace = false;
      this.$store.state.home = true;
      this.$store.state.headerTitle = this.texts.dados_produto;
    }
  }
};
</script>

<style lang="scss" scoped>
#SeloEcotraceCard {
  .close-btn {
    top: 22px;
    right: 22px;
  }
}
</style>
